
import { axios } from '@/utils/request'
import { sysInfo } from '@/config'

// 新增询价产品
export function insertInquiry (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/inquiry/product',
    method: 'POST',
    data: parameter
  })
}
// 更新询价产品
export function updateInquiry (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/inquiry/product',
    method: 'POST',
    data: parameter
  })
}
// 删除询价产品
export function deleteInquiry (ids) {
  return axios({
    url: sysInfo.apiRemote + '/inquiry/product?ids=' + ids,
    method: 'DELETE'
  })
}
// 获取询价采购库列表
export function getInquiryList (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/inquiry/products',
    method: 'GET',
    params: parameter
  })
}
// 询价产品详情
export function getInquiryInfo (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/inquiry/product/detail',
    method: 'GET',
    params: parameter
  })
}
// 采购明细列表
export function getPurchaseRecords (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/contract/purchase/products',
    method: 'GET',
    params: parameter
  })
}
// 询价记录保存
export function saveInquiryRecord (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/inquiry/product/record',
    method: 'POST',
    data: parameter
  })
}
// 询价记录删除
export function deleteInquiryRecord (ids) {
  return axios({
    url: sysInfo.apiRemote + '/inquiry/product/record?ids=' + ids,
    method: 'DELETE'
  })
}
// 询价记录列表
export function getInquiryRecords (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/inquiry/product/records',
    method: 'GET',
    params: parameter
  })
}
// 询价记录详情
export function inquiryRecordDetail (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/inquiry/product/record/detail',
    method: 'GET',
    params: parameter
  })
}
